import {defineMessages} from 'react-intl';

export default defineMessages({
  defaultLabel: {
    id: 'Myaccount.ReactUIkit.PhoneInput.Label.default',
    defaultMessage: 'Phone number',
  },
});
